import { PageLayout } from '@ipfabric/ui-components/PageLayout/PageLayout';
import { useLocale } from 'containers/App/LocaleContext';
import { Permissions } from 'containers/Permissions/Permissions';
import type { FC } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

/**
 * The page we show when the user visits a url and doesn't have sufficient permissions
 */
export const PermissionsRequiredPage: FC = () => {
  const permissionsRequiredMsg = useLocale().permissionsRequired;

  return (
    <PageLayout>
      <Helmet title={permissionsRequiredMsg.title} />
      <h1 className='text-level-3 my-lg'>{permissionsRequiredMsg.title}</h1>
      <p>{permissionsRequiredMsg.message}</p>
      <Permissions requiredScope={['read']}>
        <Link to='/dashboard/overview'>
          {permissionsRequiredMsg.continueMessage}
        </Link>
      </Permissions>
    </PageLayout>
  );
};
